import { HStack, Modal, ModalOverlay } from '@chakra-ui/react';
import { PrimaryButton } from '../buttons/PrimaryButton';
import { defaultFilter as defaultTypeFilter } from '../orders/enums/orderTypeOptions';
import {
  Box,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Thead,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';
import Filters from '../filters/Filters';
import ErrorModal from '../modals/ErrorModal';
import PrintModal from '../modals/PrintModal';
import AssignNewPrintBatchModal from '../modals/AssignNewPrintBatchModal';
import HeadingsRow from './HeadingsRow';
import OrderRows from './OrderRows';

const distanceFromTop = '112px';
const distanceFromBottom = '79px';

const OrderView = ({ requestState, setRequestState }) => {
  const printModalDisclosure = useDisclosure();
  const confirmModalDisclosure = useDisclosure();
  const loadMoreHandler = () => {
    setRequestState({
      ...requestState,
      page: requestState.page + 1,
      isLoadingNextPage: true,
    });
  };
  const countSelectedOrders = () => {
    const count = requestState.selectedOrders.size;
    if (count === 0) return;
    return `(${count})`;
  };

  const handleReload = e => {
    setRequestState({
      isLoading: true,
      page: 1,
      sortColumn: 'completedUtcDate',
      sortOrder: 'desc',
      filterQuery: {
        ...requestState.filterQuery,
        orderStatus: 3,
        type: defaultTypeFilter,
        includeTestOrders: false,
        isPrintReady: true,
        pageSize: 30,
      },
      orders: [],
      isLoadingNextPage: false,
      selectedOrders: new Set(),
      refreshOrders: 0,
      error: null,
    });
  };
  const handlePrintModalClose = () => {
    printModalDisclosure.onClose();
  };
  const handleConfirmModalClose = () => {
    confirmModalDisclosure.onClose();
  };
  const orderForNewPrintBatch = [...requestState.selectedOrders][0];
  return (
    <Flex flexDirection="column" margin="0 10px" overflowX="scroll">
      <Box
        border="1px"
        borderColor="brand.secondary"
        marginBottom="21px"
        minH={`calc(100vh - ${distanceFromTop} - ${distanceFromBottom})`}
      >
        <PrintModal
          isOpen={printModalDisclosure.isOpen}
          onClose={handlePrintModalClose}
          selectedOrders={requestState.selectedOrders}
          onSuccessClose={handleReload}
        />
        <AssignNewPrintBatchModal
          isOpen={confirmModalDisclosure.isOpen}
          onClose={handleConfirmModalClose}
          onSuccessClose={handleReload}
          orderId={orderForNewPrintBatch?.id}
        />
        {!!requestState.error && (
          <Modal isOpen={!!requestState.error} onClose={handlePrintModalClose}>
            <ModalOverlay data-testid="overlay" />
            <ErrorModal error={requestState.error} onClose={handleReload} />
          </Modal>
        )}

        <Flex padding="6px" justifyContent="space-between" alignItems="center">
          <PrimaryButton
            text={'Reload Orders'}
            onClick={handleReload}
            isDisabled={requestState.isLoading}
            margin={5}
          />

          <Filters
            requestState={requestState}
            setRequestState={setRequestState}
          />
          <HStack margin={5} spacing={5}>
            <PrimaryButton
              text={`Send to print ${countSelectedOrders() ?? ''}`}
              onClick={printModalDisclosure.onOpen}
              isDisabled={!requestState.selectedOrders.size}
              mergin={500}
            />
            <PrimaryButton
              text={'Assign to new print batch'}
              onClick={confirmModalDisclosure.onOpen}
              isDisabled={
                requestState.selectedOrders.size !== 1 ||
                !orderForNewPrintBatch?.shipmentPrintBatch
              }
              marginRight="500px"
            />
          </HStack>
        </Flex>
        <TableContainer
          borderTop="1px"
          borderColor="#F3F4F6"
          minHeight="inherit"
        >
          <Table>
            <Thead>
              <HeadingsRow
                requestState={requestState}
                setRequestState={setRequestState}
              />
            </Thead>
            <Tbody>
              <OrderRows
                requestState={requestState}
                setRequestState={setRequestState}
              />
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
      <Flex justify="center">
        <PrimaryButton
          text={'Load More'}
          onClick={loadMoreHandler}
          disabled={requestState.isLoadingNextPage}
          margin={5}
        />
      </Flex>
    </Flex>
  );
};

export default OrderView;
